import { useDispatch, useSelector } from 'react-redux'

import { BASE_URL } from '../constants'
import useFetch from '../hooks/useFetch'

import { fetchSuccess, fetchStart, fetchFail } from './actions'

import { getCategoryById, getCrimeCategories } from './selectors'

export const useCrimeCategoriesFetch = () => {
  const dispatch = useDispatch()

  return useFetch(`${BASE_URL}api/IncidentCategories`, {
    onStart: () => dispatch(fetchStart()),
    onSuccess: (layers) => dispatch(fetchSuccess(layers)),
    onError: (error) => dispatch(fetchFail(error)),
  })
}

export const useCrimeCategory = (categoryId) => {
  const category = useSelector(getCategoryById)(categoryId)
  return category
}

export const useCrimeCategories = () => {
  const categories = useSelector(getCategoryById) // this seems wrong.. but it's how it is being used
  return categories
}
